import { Observable, observe, Scope } from 'wdc-cube'
import { WaitingScope } from '../../the-connection/tc_scopes'
import type {
    AccessByGroupRow,
    AccessByPageRow,
    AccessByUserRow,
    AccessDetailRow,
    AccessInactiveUserRow,
    AccessPeriodRow,
    AccessRankingRow
} from './aa_types'

@Observable
export class AccessAuditHeaderScope extends Scope {}

@Observable
export class AccessChartScope extends Scope {
    @observe() caption = ''
    @observe() loaded = false
    @observe() rows = [] as AccessPeriodRow[]
}

@Observable
export class AccessRankingScope extends Scope {
    @observe() caption = ''
    @observe() loaded = false
    @observe() rows = [] as AccessRankingRow[]
}

@Observable
export class AccessFilterPaneScope extends Scope {
    @observe() expanded = false

    @observe() start = ''
    @observe() end = ''
    @observe() groupId?: number
    @observe() userId?: number
    @observe() placeCode?: string

    @observe() groupOptions = [] as { id: number; name: string }[]
    @observe() userOptions = [] as { id: number; name: string }[]
    @observe() pageOptions = [] as { placeCode: string; pageLabel: string }[]

    @observe() isFiltering = false

    onToggleExpanded = Scope.ASYNC_ACTION
    onStartChanged = Scope.ASYNC_ACTION_STRING
    onEndChanged = Scope.ASYNC_ACTION_STRING
    onGroupChanged = Scope.ASYNC_ACTION_ONE<number | undefined>()
    onUserChanged = Scope.ASYNC_ACTION_ONE<number | undefined>()
    onPageChanged = Scope.ASYNC_ACTION_ONE<string | undefined>()
    onApply = Scope.ASYNC_ACTION
    onClear = Scope.ASYNC_ACTION
}

@Observable
export class AccessAuditScope extends Scope {
    readonly header = new AccessAuditHeaderScope()
    readonly filterPane = new AccessFilterPaneScope()
    readonly monthly = new AccessChartScope()
    readonly daily = new AccessChartScope()
    readonly topPages = new AccessRankingScope()

    @observe() waiting?: WaitingScope

    @observe() totalGroups = 0
    @observe() totalUsers = 0
    @observe() totalActiveUsers = 0
    @observe() totalPages = 0
    @observe() totalAccesses = 0

    @observe() byGroup = [] as AccessByGroupRow[]
    @observe() byUser = [] as AccessByUserRow[]
    @observe() byPage = [] as AccessByPageRow[]
    @observe() inactiveUsers = [] as AccessInactiveUserRow[]

    @observe() detailRows = [] as AccessDetailRow[]
    @observe() detailTotal = 0
    @observe() detailTruncated = false
    @observe() detailLimit = 0
}

export default AccessAuditScope
